import { Page, SelectFilter } from '@/components';
import { Heading, Flex, useTableProps } from '@blockanalitica/ui';
import EventsTable from './EventsTable';
import HistoricTabs from './HistoricTabs';
import { SURPLUS_ILKS } from '@/constants';
import { useMemo } from 'react';

export default function SurplusActivityPage() {
  const { pagination, filters, sorting } = useTableProps({
    pageSize: 10,
    initialSorting: '-datetime',
    filtersDebounceTime: 50
  });

  const selectFilterOptions = useMemo(() => {
    const options = [{ label: 'All ilks', value: '' }];
    options.push(
      ...Object.entries(SURPLUS_ILKS).map(([key, value]) => ({
        label: value,
        value: key,
        selected: key === filters.filtersApplied.ilk
      }))
    );
    return options;
  }, [filters]);

  return (
    <Page title="Surplus Activity">
      <Heading size="3">Depositors</Heading>
      <HistoricTabs />
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center">
        <Heading size="3">Surplus deposits</Heading>
        <SelectFilter
          key="ilk-filter"
          filterField="ilk"
          options={selectFilterOptions}
          {...filters}
        />
      </Flex>
      <EventsTable
        pagination={pagination}
        sorting={sorting}
        filters={filters}
      />
    </Page>
  );
}
